import { Injectable } from "@angular/core";
import { BehaviorSubject, timer, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { StatoApplicazioneService } from "../services/stato-applicazione.service";
import { StatoApplicazioneVO } from "../vo/stato-applicazioneVO";

@Injectable({
  providedIn: "root",
})
export class StatoApplicazioneStore {
  private statoGesCor: BehaviorSubject<StatoApplicazioneVO> = new BehaviorSubject<
      StatoApplicazioneVO
  >(null);
  private stato: BehaviorSubject<StatoApplicazioneVO> = new BehaviorSubject<
    StatoApplicazioneVO
  >(null);
  private errorCounter: number = 0;
  constructor(private statoApplicazioneService: StatoApplicazioneService) { }

  public avvia() {
    timer(0, 180 * 1000).subscribe(() => {
      console.log(
        "[StatoApplicazioneStore][avvia] chiamo getStatoApplicazione"
      );
      this.statoApplicazioneService.getStatoApplicazione().subscribe(
        (response) => {
          console.log("[StatoApplicazioneStore][avvia] stato app: ", response);
          this.stato.next(response);
          this.errorCounter = 0;
        },
        (err) => this.gestisciErrore(err)
      );
    });
  }

  public getStatoGesCor(): Observable<StatoApplicazioneVO> {
    return this.statoGesCor.asObservable().pipe(distinctUntilChanged());
  }

  public getStato(): Observable<StatoApplicazioneVO> {
    return this.stato.asObservable().pipe(distinctUntilChanged());
  }

  public setOnce() {
    this.statoApplicazioneService.getStatoApplicazione().subscribe(
      (response) => {
        console.log("[StatoApplicazioneStore][avvia] stato app: ", response);
        this.stato.next(response);
        this.errorCounter = 0;
      },
      (err) => this.gestisciErrore(err)
    );
  }

  private gestisciErrore(err: any) {
    console.log("[stato-applicazione] gestisciErrore - ", err);
    this.errorCounter++;
    if (this.errorCounter > 3) {
      this.errorCounter = 0;
      const statoManutenzioneForzato: StatoApplicazioneVO = {
        manutenzione: true,
        dataInizioManutenzione: new Date(),
        messaggio:
          "L'applicazione è in manutenzione straordinaria provare più tardi",
        nascondiFascicolazione: true,
        nascondiVociPhylum: true,
        nascondiSoggettiEsterni: false,
        minKbPerAttivazioneFileDiGrandiDimensioni: 0,
        minKbPerAttivazioneFileDiGrandiDimensioniSingoloDestinatario: 0,
      };
      this.stato.next(statoManutenzioneForzato);
    }
  }
}
